module.exports = __webpack_public_path__ + "media/images/sp/items/gift/kiribako_02_thumb-d22fa243fa032f07500bc849c4685a7b.jpg";